export const updateCustomerBacklightPreferences = /* GraphQL */ `
  mutation UpdateCustomerBacklightPreferences(
    $customerId: ID!
    $preferences: BacklightPreferencesInput!
  ) {
    updateCustomerBacklightPreferences(customerId: $customerId, preferences: $preferences) {
      id
      name
      email
      backlightPreferences {
        color {
          r
          g
          b
        }
        pattern
      }
    }
  }
`;

export const createHub = /* GraphQL */ `
  mutation CreateHub($input: CreateHubInput!) {
    createHub(input: $input) {
      id
      serialNumber
      macAddress
      name
      status
      latitude
      longitude
      config
    }
  }
`;

export const updateHub = /* GraphQL */ `
  mutation UpdateHub($input: UpdateHubInput!) {
    updateHub(input: $input) {
      id
      serialNumber
      macAddress
      name
      status
      latitude
      longitude
      config
    }
  }
`;

export const updateHubAddress = /* GraphQL */ `
  mutation UpdateHubAddress($input: UpdateHubAddressInput!) {
    updateHubAddress(input: $input) {
      id
      serialNumber
      macAddress
      name
      status
      latitude
      longitude
      street
      city
      state
      zip
      date
      time
      timezone
    }
  }
`;

export const updateHubConfig = /* GraphQL */ `
  mutation UpdateHubConfig($id: ID!, $config: String!) {
    updateHubConfig(id: $id, config: $config) {
      id
      serialNumber
      macAddress
      name
      status
      latitude
      longitude
      config
    }
  }
`;

export const deleteHub = /* GraphQL */ `
  mutation DeleteHub($id: ID!) {
    deleteHub(id: $id) {
      id
      serialNumber
      macAddress
      name
      status
      latitude
      longitude
      config
    }
  }
`;

export const associateHub = /* GraphQL */ `
  mutation AssociateHub($hubId: ID!) {
    associateHub(hubId: $hubId)
  }
`;

export const createSensor = /* GraphQL */ `
  mutation CreateSensor($input: CreateSensorInput!) {
    createSensor(input: $input) {
      id
      hubId
      serialNumber
      type
      name
      location
      sublocation
      status
      lastReported
    }
  }
`;

export const createSensorLink = /* GraphQL */ `
  mutation CreateSensorLink($input: CreateSensorLinkInput!) {
    createSensorLink(input: $input) {
      id
      hubId
      serialNumber
      type
      name
      location
      sublocation
      status
      lastReported
    }
  }
`;

export const createSensorGroup = /* GraphQL */ `
  mutation CreateSensorGroup($input: CreateSensorGroupInput!) {
    createSensorGroup(input: $input) {
      id
      hubId
      serialNumber
      type
      name
      location
      sublocation
      status
      lastReported
      groupId
      sensorGroupConfiguration {
        indoor
        metadata
      }
    }
  }
`;

export const updateSensor = /* GraphQL */ `
  mutation UpdateSensor($input: UpdateSensorInput!) {
    updateSensor(input: $input) {
      id
      hubId
      serialNumber
      type
      name
      location
      sublocation
      status
      lastReported
    }
  }
`;

export const updateSensorBranchCircuits = /* GraphQL */ `
  mutation UpdateSensorBranchCircuits($input: UpdateSensorBranchCircuitsInput!) {
    updateSensorBranchCircuits(input: $input) {
      id
      hubId
      serialNumber
      type
      name
      location
      sublocation
      status
      lastReported
      branchCircuits {
        circuitNumber
        breakerNumber
        powerMonitorInputNumber
        breakerType
        location
        sublocation
        underCurrentAlert
        overCurrentAlert
        underCurrentAlertCustomAmps
        overCurrentAlertCustomAmps
      }
    }
  }
`;

export const deleteSensor = /* GraphQL */ `
  mutation DeleteSensor($id: ID!) {
    deleteSensor(id: $id) {
      id
      hubId
      serialNumber
      type
      name
      location
      sublocation
      status
      lastReported
    }
  }
`;

export const createSensorEvent = /* GraphQL */ `
  mutation CreateSensorEvent($input: CreateSensorEventInput!) {
    createSensorEvent(input: $input) {
      id
      timestamp
      sensorId
      hubId
      eventType
      value
      metadata
    }
  }
`;

export const updateSensorAlertStatus = /* GraphQL */ `
  mutation UpdateSensorAlertStatus($input: UpdateSensorAlertStatusInput!) {
    updateSensorAlertStatus(input: $input) {
      id
      timestamp
      sensorId
      hubId
      alertType
      severity
      message
      value
      metadata
      status
      acknowledgedAt
      acknowledgedBy
    }
  }
`;

export const updateSensorAlertAcknowledgedState = /* GraphQL */ `
  mutation UpdateSensorAlertAcknowledgedState($input: UpdateSensorAlertAcknowledgedStateInput!) {
    updateSensorAlertAcknowledgedState(input: $input) {
      id
      timestamp
      sensorId
      hubId
      alertType
      severity
      message
      value
      metadata
      status
      acknowledgedAt
      acknowledgedBy
    }
  }
`;

export const updateSensorAlertAcknowledgedStateAnonymous = /* GraphQL */ `
  mutation UpdateSensorAlertAcknowledgedStateAnonymous(
    $input: UpdateSensorAlertAcknowledgedStateInput!
  ) {
    updateSensorAlertAcknowledgedStateAnonymous(input: $input) {
      id
      timestamp
      sensorId
      hubId
      alertType
      severity
      message
      value
      metadata
      status
      acknowledgedAt
      acknowledgedBy
    }
  }
`;

export const createServiceRequest = /* GraphQL */ `
  mutation CreateServiceRequest($input: CreateServiceRequestInput!) {
    createServiceRequest(input: $input) {
      id
      customerId
      hubId
      sensorId
      alertId
      jobNumber
      serviceType
      reason
      status
      priority
      requestedAt
      scheduledAt
      completedAt
      createdAt
      updatedAt
      customerComplaint
      customerNotes
      notes
      potentialCause
      accessInstructions
      additionalNotes
      serviceCompanyId
      technicianName
      deviceLocation
      roomType
    }
  }
`;

export const updateServiceRequest = /* GraphQL */ `
  mutation UpdateServiceRequest($input: UpdateServiceRequestInput!) {
    updateServiceRequest(input: $input) {
      id
      customerId
      hubId
      sensorId
      alertId
      jobNumber
      serviceType
      reason
      status
      priority
      requestedAt
      scheduledAt
      completedAt
      createdAt
      updatedAt
      customerComplaint
      customerNotes
      notes
      potentialCause
      accessInstructions
      additionalNotes
      serviceCompanyId
      technicianName
      deviceLocation
      roomType
    }
  }
`;

export const createCustomer = /* GraphQL */ `
  mutation CreateCustomer($input: CreateCustomerInput!) {
    createCustomer(input: $input) {
      id
      name
      email
      phone
      address
      city
      state
      zipCode
      country
      companyName
      createdAt
      updatedAt
    }
  }
`;

export const updateCustomer = /* GraphQL */ `
  mutation UpdateCustomer($input: UpdateCustomerInput!) {
    updateCustomer(input: $input) {
      id
      name
      email
      phone
      address
      city
      state
      zipCode
      country
      companyName
      createdAt
      updatedAt
    }
  }
`;

export const deleteCustomer = /* GraphQL */ `
  mutation DeleteCustomer($id: ID!) {
    deleteCustomer(id: $id) {
      id
      name
      email
      phone
      address
      city
      state
      zipCode
      country
      companyName
      createdAt
      updatedAt
    }
  }
`;

export const createServiceCompany = /* GraphQL */ `
  mutation CreateServiceCompany($input: CreateServiceCompanyInput!) {
    createServiceCompany(input: $input) {
      id
      name
      email
      phone
      address
      city
      state
      zipCode
      logoUrl
      website
      createdAt
      updatedAt
    }
  }
`;

export const updateServiceCompany = /* GraphQL */ `
  mutation UpdateServiceCompany($input: UpdateServiceCompanyInput!) {
    updateServiceCompany(input: $input) {
      id
      name
      email
      phone
      address
      city
      state
      zipCode
      logoUrl
      website
      createdAt
      updatedAt
    }
  }
`;

// HVAC Filter Alert Mutations
export const requestFilterService = /* GraphQL */ `
  mutation RequestFilterService($input: FilterServiceRequestInput!) {
    requestFilterService(input: $input) {
      id
      customerId
      customerName
      serviceCompanyId
      serviceCompanyName
      serviceType
      status
      requestedDate
      scheduledDate
      completedDate
      notes
      sensorId
      hubId
      createdAt
      updatedAt
    }
  }
`;

export const clearHvacFilterAlert = /* GraphQL */ `
  mutation ClearHvacFilterAlert($sensorId: ID!, $hubId: ID!) {
    clearHvacFilterAlert(sensorId: $sensorId, hubId: $hubId)
  }
`;

export const orderFilter = /* GraphQL */ `
  mutation OrderFilter($input: FilterOrderRequestInput!) {
    orderFilter(input: $input) {
      id
      customerId
      customerName
      serviceCompanyId
      serviceCompanyName
      serviceType
      status
      requestedDate
      scheduledDate
      completedDate
      notes
      sensorId
      hubId
      createdAt
      updatedAt
    }
  }
`;

// Power Monitor Alert Mutations
export const requestPowerMonitorService = /* GraphQL */ `
  mutation RequestPowerMonitorService($input: PowerMonitorServiceRequestInput!) {
    requestPowerMonitorService(input: $input) {
      id
      customerId
      customerName
      serviceCompanyId
      serviceCompanyName
      serviceType
      status
      requestedDate
      scheduledDate
      completedDate
      notes
      sensorId
      hubId
      createdAt
      updatedAt
    }
  }
`;

export const clearPowerMonitorAlert = /* GraphQL */ `
  mutation ClearPowerMonitorAlert($sensorId: ID!, $hubId: ID!) {
    clearPowerMonitorAlert(sensorId: $sensorId, hubId: $hubId)
  }
`;

export const requestWaterLeakService = /* GraphQL */ `
  mutation RequestWaterLeakService($input: WaterLeakServiceRequestInput!) {
    requestWaterLeakService(input: $input) {
      id
      customerId
      customerName
      serviceCompanyId
      serviceCompanyName
      serviceType
      status
      requestedDate
      scheduledDate
      completedDate
      notes
      sensorId
      hubId
      createdAt
      updatedAt
    }
  }
`;

export const clearWaterLeakAlert = /* GraphQL */ `
  mutation ClearWaterLeakAlert($sensorId: ID!, $hubId: ID!) {
    clearWaterLeakAlert(sensorId: $sensorId, hubId: $hubId)
  }
`;
export const requestHumidityService = /* GraphQL */ `
  mutation RequestHumidityService($input: HumidityServiceRequestInput!) {
    requestHumidityService(input: $input) {
      id
      customerId
      customerName
      serviceCompanyId
      serviceCompanyName
      serviceType
      reason
      status
      priority
      hubId
      sensorId
      alertId
      notes
      accessInstructions
      deviceLocation
      roomType
      requestedAt
      scheduledAt
      completedAt
      createdAt
      updatedAt
    }
  }
`;

export const clearHumidityAlert = /* GraphQL */ `
  mutation ClearHumidityAlert($sensorId: ID!, $hubId: ID!) {
    clearHumidityAlert(sensorId: $sensorId, hubId: $hubId)
  }
`;
